import appStore from "store/index";

import { REQUESTERROR } from "store/actions/type/toaster";

import { lStorage } from "utils/storage";

import { getKeyCloakRefreshToken, logout } from "utils/common";

const interceptor = (ax, logauth) => {
  ax.interceptors.request.use(
    async (config) => {
      let token = lStorage.get("logauthInfo")
        ? lStorage.get("logauthInfo")
        : null;
      const parseToken = JSON.parse(token);
      let authToken = null;
      if (parseToken) {
        authToken = await getKeyCloakRefreshToken();
      }
      config.headers = {
        Authorization: `Bearer ${authToken || parseToken.token}`,
      };
      return config;
    },

    (error) => {
      Promise.reject(error);
    }
  );

  ax.interceptors.response.use(
    (next) => {
      return Promise.resolve(next);
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        logout();
      } else {
        appStore.dispatch({
          type: REQUESTERROR,
          payload: {
            show: true,
            toastMessage: {
              severity: "error",
              summary: "Something Went Wrong",
              detail: error.message,
            },
          },
        });
      }
      return Promise.reject(error);
    }
  );

  logauth.interceptors.request.use(
    async (config) => {
      let token = lStorage.get("logauthInfo")
        ? lStorage.get("logauthInfo")
        : null;
      const parseToken = JSON.parse(token);   
      config.headers = {
        Authorization: `${parseToken.token}`,
      };
      return config;
    },

    (error) => {
      Promise.reject(error);
    }
  );
  logauth.interceptors.response.use(
    (next) => {
      return Promise.resolve(next);
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        logout();
      } else {
        appStore.dispatch({
          type: REQUESTERROR,
          payload: {
            show: true,
            toastMessage: {
              severity: "error",
              summary: "Something Went Wrong",
              detail: error.message,
            },
          },
        });
      }
      return Promise.reject(error);
    }
  );
};

export { interceptor };
